import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Snackbar } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import { clearNotification } from 'actions/status'

const Notifications = () => {
  const dispatch = useDispatch()
  const { message, notificationType, duration } = useSelector(({ status: { notification } }) => notification)

  function handleClose(event, reason) {
    if(reason !== 'clickaway') {
      dispatch(clearNotification())
    }
  }

  return (
    <Snackbar open={!!message} autoHideDuration={duration} onClose={handleClose}>
      <Alert onClose={handleClose} severity={notificationType}>
        {message}
      </Alert>
    </Snackbar>
  )
}

export default Notifications
